import { motion } from 'framer-motion';
import { Construction, BookOpen, Github, FileText } from 'lucide-react';

const ResourcesPage = () => {
  const comingSoon = [
    { icon: BookOpen, title: 'Full Documentation', description: 'API reference, installation guides, troubleshooting' },
    { icon: Github, title: 'GitHub Repository', description: 'Source code, issues, pull requests' },
    { icon: FileText, title: 'Blog Posts', description: 'Technical deep-dives and tutorials' },
    { icon: Construction, title: 'Community Forum', description: 'Discord server and discussions' }
  ];

  return (
    <div className="min-h-screen pt-24 pb-16 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <Construction className="w-24 h-24 text-green-400 mx-auto mb-6" />
          <h1 className="text-5xl md:text-6xl font-bold text-green-400 mb-4">
            Resources Coming Soon
          </h1>
          <p className="text-xl text-gray-300">
            Documentation, code repositories, and community resources are currently being prepared
          </p>
        </motion.div>

        {/* Coming Soon Grid */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12"
        >
          {comingSoon.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2 + index * 0.1 }}
              className="bg-black/50 border border-green-500/20 rounded-lg p-6"
            >
              <item.icon className="w-12 h-12 text-green-400 mb-4" />
              <h3 className="text-xl font-bold text-green-400 mb-2">{item.title}</h3>
              <p className="text-gray-300">{item.description}</p>
            </motion.div>
          ))}
        </motion.div>

        {/* Stay Tuned */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="bg-gray-900/30 backdrop-blur border border-green-500/30 rounded-xl p-8 text-center"
        >
          <h3 className="text-2xl font-bold text-green-400 mb-4">Stay Tuned</h3>
          <p className="text-gray-300">
            Documentation, code repositories, and community resources are currently being prepared.
            Check back soon for updates.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default ResourcesPage;
